const data = {
  title: "Floor 2-7",
  musicTrack: "MUSIC_WORLD2",
  theme: "GREEN",
  tilesWidth: 11,
  tilesHeight: 11,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 6,
      y: 6,
    },
    {
      type: "WATER",
      x: 7,
      y: 5,
    },
    {
      type: "WATER",
      x: 7,
      y: 6,
    },
    {
      type: "WATER",
      x: 7,
      y: 7,
    },
    {
      type: "WATER",
      x: 6,
      y: 7,
    },
    {
      type: "WATER",
      x: 5,
      y: 7,
    },
    {
      type: "WATER",
      x: 5,
      y: 6,
    },
    {
      type: "WATER",
      x: 5,
      y: 5,
    },
    {
      type: "WATER",
      x: 6,
      y: 5,
    },
    {
      type: "THIEF",
      x: 8,
      y: 6,
    },
    {
      type: "WALL",
      x: 5,
      y: 4,
    },
    {
      type: "WALL",
      x: 7,
      y: 4,
    },
    {
      type: "WALL",
      x: 8,
      y: 5,
    },
    {
      type: "WALL",
      x: 8,
      y: 7,
    },
    {
      type: "WALL",
      x: 7,
      y: 8,
    },
    {
      type: "WALL",
      x: 5,
      y: 8,
    },
    {
      type: "WALL",
      x: 4,
      y: 7,
    },
    {
      type: "WALL",
      x: 4,
      y: 5,
    },
    {
      type: "LOCK",
      x: 6,
      y: 4,
      color: "GREEN",
    },
    {
      type: "WATER_PICKUP",
      x: 10,
      y: 2,
    },
    {
      type: "WATER",
      x: 9,
      y: 7,
    },
    {
      type: "WATER",
      x: 10,
      y: 7,
    },
    {
      type: "WATER",
      x: 11,
      y: 7,
    },
    {
      type: "WATER",
      x: 11,
      y: 6,
    },
    {
      type: "WATER",
      x: 9,
      y: 6,
    },
    {
      type: "WATER",
      x: 9,
      y: 5,
    },
    {
      type: "WATER",
      x: 10,
      y: 5,
    },
    {
      type: "WATER",
      x: 11,
      y: 5,
    },
    {
      type: "WATER",
      x: 3,
      y: 5,
    },
    {
      type: "WATER",
      x: 1,
      y: 5,
    },
    {
      type: "WATER",
      x: 2,
      y: 5,
    },
    {
      type: "WATER",
      x: 1,
      y: 6,
    },
    {
      type: "WATER",
      x: 1,
      y: 7,
    },
    {
      type: "WATER",
      x: 2,
      y: 7,
    },
    {
      type: "WATER",
      x: 3,
      y: 7,
    },
    {
      type: "WATER",
      x: 3,
      y: 6,
    },
    {
      type: "WATER",
      x: 5,
      y: 9,
    },
    {
      type: "WATER",
      x: 5,
      y: 10,
    },
    {
      type: "WATER",
      x: 5,
      y: 11,
    },
    {
      type: "WATER",
      x: 6,
      y: 11,
    },
    {
      type: "WATER",
      x: 6,
      y: 10,
    },
    {
      type: "WATER",
      x: 6,
      y: 9,
    },
    {
      type: "WATER",
      x: 7,
      y: 9,
    },
    {
      type: "WATER",
      x: 7,
      y: 10,
    },
    {
      type: "WATER",
      x: 7,
      y: 11,
    },
    {
      type: "WATER",
      x: 6,
      y: 3,
    },
    {
      type: "WATER",
      x: 5,
      y: 3,
    },
    {
      type: "WATER",
      x: 5,
      y: 1,
    },
    {
      type: "WATER",
      x: 6,
      y: 1,
    },
    {
      type: "WATER",
      x: 3,
      y: 9,
    },
    {
      type: "WATER",
      x: 9,
      y: 9,
    },
    {
      type: "WATER",
      x: 9,
      y: 10,
    },
    {
      type: "WATER",
      x: 11,
      y: 10,
    },
    {
      type: "WATER",
      x: 11,
      y: 9,
    },
    {
      type: "WATER",
      x: 10,
      y: 10,
    },
    {
      type: "WATER",
      x: 11,
      y: 11,
    },
    {
      type: "WATER",
      x: 10,
      y: 11,
    },
    {
      type: "WATER",
      x: 9,
      y: 11,
    },
    {
      type: "WATER",
      x: 3,
      y: 10,
    },
    {
      type: "WATER",
      x: 3,
      y: 11,
    },
    {
      type: "WATER",
      x: 2,
      y: 11,
    },
    {
      type: "WATER",
      x: 1,
      y: 11,
    },
    {
      type: "WATER",
      x: 1,
      y: 10,
    },
    {
      type: "WATER",
      x: 2,
      y: 10,
    },
    {
      type: "WATER",
      x: 2,
      y: 9,
    },
    {
      type: "WATER",
      x: 1,
      y: 9,
    },
    {
      type: "WATER",
      x: 10,
      y: 6,
    },
    {
      type: "WATER",
      x: 9,
      y: 1,
    },
    {
      type: "WATER",
      x: 10,
      y: 1,
    },
    {
      type: "WATER",
      x: 11,
      y: 1,
    },
    {
      type: "WATER",
      x: 11,
      y: 2,
    },
    {
      type: "WATER",
      x: 11,
      y: 3,
    },
    {
      type: "WATER",
      x: 10,
      y: 3,
    },
    {
      type: "WATER",
      x: 9,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 8,
    },
    {
      type: "WALL",
      x: 11,
      y: 8,
    },
    {
      type: "WALL",
      x: 9,
      y: 8,
    },
    {
      type: "WALL",
      x: 4,
      y: 8,
    },
    {
      type: "WALL",
      x: 1,
      y: 8,
    },
    {
      type: "WALL",
      x: 3,
      y: 8,
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 8,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 8,
      isRaised: false,
    },
    {
      type: "WALL",
      x: 8,
      y: 9,
    },
    {
      type: "WALL",
      x: 8,
      y: 11,
    },
    {
      type: "WALL",
      x: 1,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 3,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 9,
    },
    {
      type: "WALL",
      x: 4,
      y: 11,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "WALL",
      x: 9,
      y: 4,
    },
    {
      type: "WALL",
      x: 11,
      y: 4,
    },
    {
      type: "WATER",
      x: 10,
      y: 9,
    },
    {
      type: "THIEF",
      x: 4,
      y: 10,
    },
    {
      type: "KEY",
      x: 10,
      y: 6,
      color: "BLUE",
    },
    {
      type: "LOCK",
      x: 4,
      y: 6,
      color: "BLUE",
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 8,
      isRaised: false,
    },
    {
      type: "SWITCH",
      x: 8,
      y: 10,
    },
    {
      type: "CHIP",
      x: 2,
      y: 10,
    },
    {
      type: "KEY",
      x: 2,
      y: 6,
      color: "GREEN",
    },
    {
      type: "WALL",
      x: 4,
      y: 3,
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WALL",
      x: 8,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 1,
    },
    {
      type: "WATER",
      x: 7,
      y: 1,
    },
    {
      type: "WATER",
      x: 7,
      y: 3,
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 4,
      isRaised: false,
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 4,
      isRaised: false,
    },
    {
      type: "THIEF",
      x: 4,
      y: 2,
    },
    {
      type: "WATER",
      x: 2,
      y: 6,
    },
  ],
};

export default data;
